/** @jsxImportSource @emotion/react */

import {css} from "@emotion/react";
import {GuidlinesProps} from ".";
import GuidelinesSection from "./GuidelinesSection";
import YesNoButtons from "./YesNoButtons";
import buildingSvg from "assets/images/building.svg";
import dollarDocumentSvg from "assets/images/dollar-document.svg";
import financeDurationSvg from "assets/images/finance-duration.svg";
import buildingConstructionSvg from "assets/images/building-construction.svg";
import coastalSvg from "assets/images/coastal.svg";
import Ul from "./Ul";
import ButtonsContainer from "./ButtonsContainer";
import QuestionTitle from "./QuestionTitle";

export default function HabitationalGuidelines({onYes, onNo}: GuidlinesProps) {
  return (
    <div
      css={css`
        display: flex;
        gap: 5px;
        flex-direction: column;
      `}
    >
      <QuestionTitle>
        Does this risk location meet the guidelines outlined below?{" "}
      </QuestionTitle>
      <GuidelinesSection title="Lines of Business" svgUrl={buildingSvg}>
        <Ul>
          <li>
            Apartment buildings that are 3+ units with no mercantile exposure
          </li>
          <li>Condominium Associations</li>
        </Ul>
      </GuidelinesSection>
      <GuidelinesSection title="TIV Limits" svgUrl={dollarDocumentSvg}>
        <Ul>
          <li>
            Non-sprinklered frame structures do not exceed $2M per location
          </li>
          <li>Sprinklered frame structures do not exceed $5M per location</li>
          <li>All other construction types do not exceed $10M per location</li>
        </Ul>
      </GuidelinesSection>
      <GuidelinesSection title="GL Limits" svgUrl={financeDurationSvg}>
        <Ul>
          <li>
            Primary Limits up to $2M/$4M if written as a BOP (available for NY
            risks built in the past 35 years)
          </li>
          <li>Primary Limits $1M/$2M if written as a commercial package</li>
        </Ul>
      </GuidelinesSection>
      <GuidelinesSection
        title="Construction Types"
        svgUrl={buildingConstructionSvg}
      >
        <Ul>
          <li>
            No frame construction in the boroughs of NYC with the exception of
            Staten Island
          </li>
        </Ul>
      </GuidelinesSection>
      <GuidelinesSection title="Coastal Restrictions" svgUrl={coastalSvg}>
        <Ul>
          <li>Up to 1000 feet from water</li>
          <li>No Barrier Islands</li>
        </Ul>
      </GuidelinesSection>
      <ButtonsContainer>
        <YesNoButtons onYes={onYes} onNo={onNo} />
      </ButtonsContainer>
    </div>
  );
}
